var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('Message',{attrs:{"title":_vm.$tc('title'),"primaryButton":_vm.primaryButton,"message":_vm.$tc('subtitle')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }